import { useState, useEffect } from "react";
import {OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import vector from "../assets/images/star-img.svg";
import linkImg from "../assets/images/link-img.svg";
import { getData, postData } from "../../axios/apiHelper";
import { ENDPOINT } from "../../axios/apiConfig";
import { loader } from "../../loader";
import { ModalContent } from "./NarrativePopup";
let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;

function LinkWithTooltip({ id, children, href, tooltip }) {
  return (
    <OverlayTrigger
      overlay={<Tooltip id={id}><div dangerouslySetInnerHTML={{ __html: tooltip }} /></Tooltip>}
      placement="top"
      delayShow={300}
      delayHide={150}
    >
      <a href={href}>{children}</a>
    </OverlayTrigger>
  );
}

function Narratives({ value, handleToggle, ...props }) {
  const isMaster = value === 1 || value === "1"; // Accepts number or string
  const toggle = () => {
    handleToggle(isMaster ? 0 : 1);
  };
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [currentOpenedNarrative, setCurrentOpenedNarrative] = useState({});
  const [ageGroups, setAgeGroups] = useState([]);
  const [categories, setCategories] = useState([]);
  const [narratives, setNarratives] = useState([]);
  const [selectedMasterId, setSelectedMasterId] = useState(null);
  const [allTags, setAllTags] = useState([]);
  const [selection, setSelection] = useState(null);
  const [narration_type, setNarrationType] = useState(1);

  const fetchAgeCategoriesData = async (isFirst= false) => {
    try {
       if (!isFirst) {loader("show");}
      const res = await getData(ENDPOINT.CATEGORIES_AGE_GROUP);
      setAgeGroups(res?.data?.data?.ageGroups || []);
      setCategories(res?.data?.data?.categories || []);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
       if (!isFirst) {loader("hide");}
    }
  };

  const handleShow = (matched) => {
    setCurrentOpenedNarrative(matched);
    setShow((prev) => !prev);
  };

  const fetchNarrativeCardData = async (isFirst = false) => {
    try {
      if (!isFirst) {loader("show");}
   
      const res = await postData(ENDPOINT.NARATIVES, { narration_type });
      setNarratives(res?.data?.data || []);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
       if (!isFirst) {loader("hide");;}
    }
  };

  const fetchTopics = async (isFirst= false) => {
    try {
       if (!isFirst) {loader("show");}
      const res = await postData(ENDPOINT.GETALLTOPICS);
      setAllTags(res?.data?.data || []);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      if (!isFirst) {loader("hide");}
    }
  };
  const fetchAllData = async () => {
    try {
      loader("show");
      await Promise.all([
        fetchNarrativeCardData(true),
        fetchAgeCategoriesData(true),
        fetchTopics(true)
      ]);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      loader("hide");
    }
  };
  useEffect(() => {
    fetchAllData();
  }, [narration_type]);

  const handleCardSelect = (id, masterCellId, img) => {
    if (img === linkImg) {
      setSelection((prev) =>
        prev && prev.type === "link" && prev.linkId === id
          ? null
          : { type: "link", masterId: masterCellId, linkId: id }
      );
    } else {
      const targetId = masterCellId || id;
      setSelection((prev) =>
        prev && prev.type === "master" && prev.masterId === targetId
          ? null
          : { type: "master", masterId: targetId }
      );
    }
  };

  return (
    <>
      <div className="col right-sidebar narratives">
        <div className="custom-container">
          <Row>
            <div className="tabs-data">
              <Tabs
                defaultActiveKey="narratives"
                id="narratives-tabs"
                onSelect={(key) => {
                  if (key === "female") {
                    setNarrationType(2);
                  } else {
                    setNarrationType(1);
                  }
                }}
              >
                <Tab eventKey="narratives" title="Narratives">
                  <Table className="narrative-table" responsive>
                    <thead>
                      <tr>
                        <th>&nbsp;</th>
                        {ageGroups.map((age) => (
                          <th key={age.id}>
                            {age.label}
                            {
                              age.min_age == 0 ? (
                                <>
                                <br />
                               Age  &lt;{age.max_age}
                              </>
                              ):
                              age.min_age !== null && age.max_age !== null && (
                                <>
                                  <br />
                                  Age {age.min_age}-{age.max_age}
                                </>
                              )
                            }
                            {age.min_age !== null && age.max_age === null && (
                              <>
                                <br />
                                Age &gt;{age.min_age}
                              </>
                            )}
                          </th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {narratives?.length > 0 ? (
                        categories.map((cat) => (
                          <tr key={cat.id}>
                            <th>{cat.name}</th>
                            {ageGroups.map((age) => {
                              const matched = narratives.find(
                                (n) =>
                                  n.category_id === cat.id &&
                                  n.age_group_id === age.id
                              );

                              return (
                                <td key={`${cat.id}-${age.id}`}>
                                  {matched ? (
                                    <NarrativeCard
                                      id={matched?.id}
                                      masterCellId={matched?.master_cell_id}
                                      status={matched?.status}
                                      date={matched?.updated_at}
                                      img={
                                        matched?.type === 2 ? linkImg : vector
                                      }
                                      handleShow={() => handleShow(matched)}
                                      selectedMasterId={selectedMasterId}
                                      onSelect={handleCardSelect}
                                    />
                                  ) : null}
                                </td>
                              );
                            })}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={ageGroups.length + 1}>
                            <div className="no_found">
                              <p>No data found</p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Tab>
                <Tab eventKey="female" title="Female">
                  <Table className="narrative-table" responsive>
                    <thead>
                      <tr>
                        <th>&nbsp;</th>
                        {ageGroups.map((age) => (
                          <th key={age.id}>
                            {age.label}
                            {
                              age.min_age == 0 ? (
                                <>
                                <br />
                               Age  &lt;{age.max_age}
                              </>
                              ):
                              age.min_age !== null && age.max_age !== null && (
                                <>
                                  <br />
                                  Age {age.min_age}-{age.max_age}
                                </>
                              )
                            }
                            {age.min_age !== null && age.max_age === null && (
                              <>
                                <br />
                                Age &gt;{age.min_age}
                              </>
                            )}
                          </th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {narratives?.length > 0 ? (
                        categories.map((cat) => (
                          <tr key={cat.id}>
                            <th>{cat.name}</th>
                            {ageGroups.map((age) => {
                              const matched = narratives.find(
                                (n) =>
                                  n.category_id === cat.id &&
                                  n.age_group_id === age.id
                              );

                              return (
                                <td key={`${cat.id}-${age.id}`}>
                                  {matched ? (
                                    <NarrativeCard
                                      id={matched?.id}
                                      masterCellId={matched?.master_cell_id}
                                      status={matched?.status}
                                      date={matched?.updated_at}
                                      img={
                                        matched?.type === 2 ? linkImg : vector
                                      }
                                      handleShow={() => handleShow(matched)}
                                      selectedMasterId={selectedMasterId}
                                      onSelect={handleCardSelect}
                                    />
                                  ) : null}
                                </td>
                              );
                            })}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={ageGroups.length + 1}>
                            <div className="no_found">
                              <p>No data found</p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Tab>
              </Tabs>
              <div className="symbol-status">
                <div className="symbols-type">
                  <p>
                    Types:{" "}
                    <LinkWithTooltip tooltip="Master: Original source — other narratives can link to it.
                      <br /><br />
                      Linked: Inherits content from a Master. Updates to the Master are applied here automatically.">
                            <img
                            src={
                                path_image +
                                "info_circle_icon.svg"
                            }
                            alt="Link"
                            />
                        </LinkWithTooltip>
                  </p>
                  <div className="live-symbol">
                    <img className="vector" alt="star Image" src={vector} />
                    <div className="text-wrapper-2">Master</div>
                  </div>
                  <div className="live-symbol">
                    <img className="vector" alt="Vector" src={linkImg} />
                    <div className="text-wrapper-2">Linked</div>
                  </div>
                </div>
              </div>
            </div>
          </Row>
        </div>
      </div>
      {show && (
        <ModalContent
          setAllTags={setAllTags}
          allTags={allTags}
          currentOpenedNarrative={currentOpenedNarrative}
          narratives={narratives}
          categories={categories}
          ageGroups={ageGroups}
          handleClose={handleClose}
          setShow={setShow}
          fetchAllData={fetchAllData}
        />
      )}
    </>
  );

  // Helper component for narrative card
  function NarrativeCard({
    id,
    masterCellId,
    status,
    date,
    img,
    handleShow = null,
    onSelect,
  }) {
    if (status === "Not applicable") {
      return (
        <div className="narrative-card not-applicable">
          <div className="no-data">Not applicable</div>
        </div>
      );
    }

    if (status === "missing") {
      return (
        <div className="narrative-card missing">
          <div className="frame">
            <div className="status">
              <div className="text-wrapper missing">Missing</div>
            </div>
          </div>
        </div>
      );
    }

    const isSelected =
      selection &&
      ((selection.type === "master" &&
        (id === selection.masterId || masterCellId === selection.masterId)) ||
        (selection.type === "link" &&
          (id === selection.linkId || id === selection.masterId)));

    return (
     <div
     className={`narrative-card ${isSelected ? "selected" : ""} ${
     status === "Missing" ? "missing" : ""
     }`}
    >
        {status !== "Missing" ? 
        <div className="link" onClick={() => onSelect(id, masterCellId, img)}>
          <img
            className={img === linkImg ? "link-img" : "vector"}
            alt="Vector"
            src={img}
          />
        </div> : null}
        <div className="frame">
          <div className="status">
            <div
              onClick={handleShow ? handleShow : null}
              className={`text-wrapper ${
                status.toLowerCase() === "not applicable"
                  ? "not-applicable"
                  : status.toLowerCase()
              }`}
            >
              {status.charAt(0).toUpperCase() + status.slice(1)}
            </div>
          </div>
           {status !== "Missing" ?
           <div className="narrative-date">
            {date}
          </div>: ""}
        </div>
      </div>
    );
  }
}

export default Narratives;
